import api from '../api/axios';

const getAll = (skip = 0, take = 1000000, withDeleted = false) => {
  const response = api.get(
    `/workDescription?skip=${skip}&take=${take}&sort=deletedAt%2Cdesc&sort=id%2Casc&withDeleted=${withDeleted}`,
  );

  return response;
};

const getById = (id) => {
  const response = api.get(`/workDescription/${id}`);

  return response;
};

const create = (item) => {
  const response = api.post(`/workDescription`, item);

  return response;
};

const update = (id, updatedItem) => {
  const response = api.patch(`/workDescription/${id}`, updatedItem);

  return response;
};

const remove = (id) => {
  const response = api.delete(`/workDescription/${id}`);

  return response;
};

const restore = (id) => {
  const response = api.get(`/workDescription/${id}/restore`);

  return response;
};

const search = (skip = 0, take = 1000000, query, withDeleted = false, options = {}) => {
  const response = api.get(`/workDescription?skip=${skip}&take=${take}&sort=deletedAt%2Cdesc&query=${query}`, {
    ...options,
  });

  return response;
};

const workDescriptionServices = {
  getAll,
  getById,
  create,
  update,
  remove,
  restore,
  search,
};

export default workDescriptionServices;

